import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
/**
 * Creates a screen context registry: a plain observable store of what is
 * currently on screen. Registrations stack in insertion order (page → panel →
 * modal). Framework-free so it can be unit tested and reused outside React;
 * the React bindings live in `SituationalAwarenessProvider` and the
 * `useCurrentScreenContexts` / `useVisibleScreenContext` hooks.
 *
 * @returns A new, empty registry
 */
function createScreenContextRegistry() {
  // Map preserves insertion order, giving the page → panel → modal stack
  var entries = new Map();
  var listeners = new Set();
  var nextEntryId = 0;
  var cachedContexts = null;
  function notify() {
    cachedContexts = null;
    listeners.forEach(function (listener) {
      return listener();
    });
  }
  return {
    register: function register(descriptor) {
      var entryId = nextEntryId;
      nextEntryId += 1;
      entries.set(entryId, descriptor);
      notify();
      var removed = false;
      return function unregister() {
        if (removed) {
          return;
        }
        removed = true;
        entries.delete(entryId);
        notify();
      };
    },
    getContexts: function getContexts() {
      // Cached so repeated calls return a stable reference between
      // changes, as required by useSyncExternalStore
      if (!cachedContexts) {
        cachedContexts = _toConsumableArray(entries.values());
      }
      return cachedContexts;
    },
    subscribe: function subscribe(listener) {
      listeners.add(listener);
      return function unsubscribe() {
        listeners.delete(listener);
      };
    }
  };
}
export default createScreenContextRegistry;